import { Navigate } from "react-router-dom";
import { Leaf } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Leaf size={48} weight="duotone" className="text-[var(--brand-primary)] mx-auto mb-4 animate-pulse" />
          <p className="text-[var(--text-secondary)] font-['Manrope']">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/welcome" replace />;
  }

  if (!user.has_paid && user.role !== "admin") {
    return <Navigate to="/pricing" replace />;
  }

  return children;
};

const AuthRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Leaf size={48} weight="duotone" className="text-[var(--brand-primary)] mx-auto mb-4 animate-pulse" />
          <p className="text-[var(--text-secondary)] font-['Manrope']">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { loading } = useAuth();

  if (loading) return null;

  return children;
};

const GuestRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user && user.has_paid) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const ViewOnlyRoute = ({ children }) => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Leaf size={48} weight="duotone" className="text-[var(--brand-primary)] mx-auto mb-4 animate-pulse" />
          <p className="text-[var(--text-secondary)] font-['Manrope']">Loading...</p>
        </div>
      </div>
    );
  }

  return children;
};

export { ProtectedRoute, AuthRoute, PublicRoute, GuestRoute, ViewOnlyRoute };
